import styled from 'styled-components';
import { Stack as StackCommon } from '../../../../../../Stack';

export const Container = styled.div`
  max-height: 420px;
`;

export const ScrollView = styled.div<{
  centerItems: boolean;
}>`
  display: flex;
  flex-direction: row;
  justify-content: ${(props) => (props.centerItems ? 'center ' : 'flex-start')};
  overflow-x: hidden;
  align-items: center;
  padding: 0 3px; // for focus outline on tab
`;

// + 40 for 20px top/bottom space to prevent cards from pushing its outer div when hovered
export const Stack = styled(StackCommon)<{ height: number }>`
  height: ${({ height }) => `${height + 44}px`};
  margin-bottom: 16px;

  > div:last-child {
    padding-right: 16px;
  }
`;

export const NavigationWrapper = styled.div`
  display: flex;
  justify-content: center;
`;

export const FlippingCardContainer = styled.div`
  height: 100%;
`;
